<template>
  <b-row>
    <b-col sm="12">
      <b-card>
        <b-row>
          <b-col sm="7">
            <h4 id="traffic" class="card-title mb-0">Recibos Provisorios</h4>            
            <div class="small text-muted">Generación de recibos sin aprobación</div>
          </b-col>
          
          <b-col sm="5">
            <b-col sm="12" class="d-none d-md-block" v-if="!table.mostrarFiltros">
              <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" @click="table.mostrarFiltros=true" v-b-tooltip.hover title="Mostrar filtros">
                <i class="fa fa-filter"></i> Mostrar Filtros
              </b-button>
            </b-col>
            <b-col sm="12" class="d-none d-md-block" v-else>
              <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" v-if="table.mostrarFiltros" @click="table.mostrarFiltros=false" v-b-tooltip.hover title="Ocultar filtros">
                <i class="fa fa-window-close"></i>
              </b-button>
            </b-col>
          </b-col>                    
        </b-row>
      </b-card>

      <b-card id="list-receipts" v-if="table.mostrarFiltros">
        <b-row v-if="table.mostrarFiltros">
          <b-col sm="10">
            <b-row>
              <b-col md="2" class="pr-0">
                <b-form-input type="date" size="md" v-model="filters.date_start" placeholder="Fecha Desde"></b-form-input>
              </b-col>
              <b-col md="2" class="pl-0">
                <b-form-input type="date" size="md" v-model="filters.date_end" placeholder="Fecha Hasta"></b-form-input>
              </b-col>  
              <b-col sm="2">
                <v-select :options="arr.filters.points_sales" v-model="filters.points_sales" placeholder="Punto de Venta" :multiple="false" :select-on-tab="true"></v-select>
              </b-col>                                                                
              <b-col sm="3">
                <v-select :options="arr.filters.customers" v-model="filters.customers" placeholder="Clientes" :multiple="true" :select-on-tab="true"></v-select>
              </b-col>  
              <b-col sm="2">
                <b-button variant="outline-dark" @click="filterReceipts()" size="sm">
                  <b-icon icon="filter" class="mr-1" style="font-size:15px;"></b-icon>              
                  Filtrar
                </b-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="2">
            <b-link>
              <export-excel
                  class = 'pull-right'
                  :data = "arr.export"
                  worksheet = "Listado de Recibos"
                  name = "list-receipts.xls">
                  Exportar Datos
              </export-excel>            
            </b-link>
          </b-col>
        </b-row>
      </b-card>

      <b-row>
        <b-col lg="8" class="pr-0" id="view_list_receipts">
          <b-card>
            <b-row>
              <b-col>
                <b-form-group>
                  <b-input-group>
                    <b-form-input type="text" 
                                  placeholder="Ingrese su busqueda para filtrar la grilla" 
                                  v-model="table.filter"
                                  size="sm">
                    </b-form-input>              
                  </b-input-group>
                </b-form-group>            
              </b-col>
              <b-col>
                <b-dropdown right text="Agregar" variant="primary" size="sm" class="btn-pill float-right ml-2" v-b-tooltip.hover title="Agregar Comprobante">
                  <b-dropdown-item @click="add('recibo')"><b-icon icon="plus-circle"></b-icon> Recibos</b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item @click="add('recibo', 'discounts')"><b-icon icon="plus-circle"></b-icon> Recibos con Descuentos (NC)</b-dropdown-item>
                </b-dropdown>       								
              </b-col>
              <b-col sm="12">
                <b-table class="mb-0 table-receipts-custom"
                        ref="table"
                        responsive
                        head-variant="dark"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="table.items"
                        :fields="table.fields"
                        :filter="table.filter"
                        :current-page="table.currentPage"
                        :per-page="table.perPage"
                        selectable
                        select-mode="single"
                        @row-selected="onRowSelected"  
                        :busy="table.isBusy"                      
                        v-if="table.items.length || table.isBusy">                       
                    
                    <template v-slot:table-colgroup="scope">
                      <col
                        v-for="field in scope.fields"                    
                        :key="field.key"
                        :style="{ width: field.width }"
                      >
                    </template> 

                    <template v-slot:table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Cargando...</strong>
                      </div>
                    </template>

                    <template v-slot:cell(business)="data">
                      {{data.item.point_sale.business.reference}}
                    </template>

                    <template v-slot:cell(id)="data">
                      <div v-if="data.item.type_voucher && data.item.point_sale">
                        {{data.item.type_voucher.name}} <br>
                        {{data.item.point_sale.point_sale.toString().padStart(4,'0') + '-' + data.item.number.toString().padStart(8,'0')}}
                      </div>
                    </template>
                    
                    <template v-slot:cell(date)="data">
                      {{moment(data.item.date).format('DD/MM/YYYY')}}
                    </template>

                    <template v-slot:cell(staff_id)="data">                      
                      <span v-if="data.item.staff_id" v-b-tooltip.hover :title="'STAFF: ' + data.item.staff.name"> 
                        <b-avatar :src="data.item.staff.image"
                                  v-if="data.item.staff.image">
                        </b-avatar>
                        <b-avatar v-else                                                                         
                                  variant="dark">
                        </b-avatar>              
                      </span>               
                    </template>
                    
                    <template v-slot:cell(customers_id)="data">  
                      <div v-if="data.item.customer">            
                        <b-avatar :src="data.item.customer.image"
                                  v-if="data.item.customer.image">
                        </b-avatar>
                        <b-avatar v-else 
                                  icon="building"                                            
                                  variant="dark">
                        </b-avatar>                                                     
                        &nbsp;<b>{{data.item.customer.name}}</b>   
                        
                        <b-icon icon="circle-fill" v-if="!data.item.customer.active" class="ml-2" variant="danger" v-b-tooltip.hover title="Cliente INACTIVO" />                                       
                      </div>
                    </template>

                    <template v-slot:cell(observations)="data">
                      <div v-if="data.item.observations" v-b-tooltip.hover :title="data.item.observations">
                        <b-icon icon="chat-square-text"></b-icon>
                      </div>                                              
                    </template>

                    <template v-slot:cell(amount_total)="data">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(data.item.amount_total)}}
                    </template>

                    <template v-slot:cell(amount_pending)="data">
                      <div v-if="data.item.amount_pending>0">
                        {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(data.item.amount_pending)}}
                      </div>
                    </template>                    
                    
                    <template v-slot:cell(f_action)="data">
                      <b-dropdown right 
                                  text="Acción" 
                                  size="sm" 
                                  variant="outline-dark" 
                                  class="pull-right" 
                                  @show="setConfigTableReceiptsShow"
                                  @hide="setConfigTableReceiptsHide"
                                  v-if="access.elements.approvalReceiptsTrashed || access.elements.disapproveReceiptsTrashed">
                        
                        <b-dropdown-item @click="approvalReceipts(data.item)" v-if="access.elements.approvalReceiptsTrashed">
                          <b-icon icon="check2-square"></b-icon> Aprobar
                        </b-dropdown-item>   
                        <b-dropdown-item @click="disapproveReceipts(data.item)" v-if="access.elements.disapproveReceiptsTrashed">
                          <b-icon icon="trash2"></b-icon> NO Aprobado
                        </b-dropdown-item>                                                                                                                          
                      </b-dropdown>
                    </template>
                </b-table>
                <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col lg="4" id="contain_details_items">
          <div id="details_items">
            <b-card>            
              <b-row>              
                <b-col md="12">
                  
                  <!-- COMPROBANTE SELECCIONADO -->
                  <b-row class="mb-3">
                    <b-col md="8">
                      <div class="crud-receipts-title" v-if="itemSelected">
                        <div class="crud-receipts-title">
                          <span class="crud-receipts-code" v-if="itemSelected.type_voucher && itemSelected.point_sale">                          
                            {{itemSelected.type_voucher.name}} {{itemSelected.point_sale.point_sale.toString().padStart(4,'0') + '-' + itemSelected.number.toString().padStart(8,'0')}}                          
                          </span><br>
                          <span v-if="itemSelected.customer">
                            {{this.itemSelected.customer.name}}                          
                          </span>                          
                        </div>
                      </div>
                    </b-col>
                    <b-col md="4">
                      <b-row>
                        <b-col md="12">
                          <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" @click="hideSub()" v-b-tooltip.hover title="Ocultar Detalle">
                            <i class="fa fa-window-close"></i>
                          </b-button>
                        </b-col>                      
                      </b-row>                   
                    </b-col>
                  </b-row>

                  <!-- DETALLE -->                
                  <b-row>
                    <b-col md="12" v-if="itemSelected">     
                      <b-link v-if="tableSubPayment.items.length || tableSubImputation.items.length" 
                              @click="openDetail()"
                              class="pull-right">
                        Ver detalle completo
                      </b-link>                                                           
                      <b-table  class="mb-0 table-receipts-sub"
                                responsive
                                head-variant="dark"
                                :hover="true"
                                :small="true"
                                :fixed="true"
                                :items="tableSubPayment.items"
                                :fields="tableSubPayment.fields"                            
                                v-if="tableSubPayment.items.length">   
                        
                        <template v-slot:table-colgroup="scope">
                          <col
                            v-for="field in scope.fields"                    
                            :key="field.key"
                            :style="{ width: field.width }"
                          >
                        </template>                         

                        <template v-slot:cell(medio)="row"> 
                          <div v-if="row.item.type=='CASH'">
                            EFECTIVO            
                          </div>
                          <div v-if="row.item.type=='CHEQUE'">
                            CHEQUE
                          </div>
                        </template>

                        <template v-slot:cell(amount)="row">
                          {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(row.item.amount_total)}}
                        </template>

                      </b-table>                      
                      <b-alert v-else variant="warning" show>No se encontraron medios de pagos</b-alert>

                      <hr>

                      <b-table  class="mt-3 table-receipts-sub"
                                responsive
                                head-variant="dark"
                                :hover="true"
                                :small="true"
                                :fixed="true"
                                :items="tableSubImputation.items"
                                :fields="tableSubImputation.fields"                            
                                v-if="tableSubImputation.items.length">   
                        
                        <template v-slot:table-colgroup="scope">
                          <col
                            v-for="field in scope.fields"                    
                            :key="field.key"
                            :style="{ width: field.width }"
                          >
                        </template>                         

                        <template v-slot:cell(voucher)="row"> 
                          {{row.item.sales.type_voucher.name + ' ' + row.item.sales.point_sale.point_sale.toString().padStart(4,'0') + '-' + row.item.sales.number.toString().padStart(8,'0')}}
                        </template>

                        <template v-slot:cell(amount)="row">
                          {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(row.item.amount_total)}}
                        </template>
                      </b-table>                      
                      <b-alert v-else variant="warning" show>No se encontraron imputaciones</b-alert>                      
                    </b-col>                    
                  </b-row>
                </b-col>
              </b-row>
            </b-card>           
          </div>
        </b-col>
      </b-row>    

      <b-row>
        <b-col lg="8" class="pr-0" id="view_footer_receipts">  
          <b-card>
            <b-row>
              <b-col>
                <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
                  <i class="fa fa-angle-double-left"></i>
                  Volver
                </b-button>                        
              </b-col>

              <b-col>
                <nav v-if="table.tablePaginate">
                  <b-pagination class="pull-right mb-0"
                                size="sm"
                                pills=""
                                :total-rows="table.tablePaginate.total"
                                :per-page="table.tablePaginate.per_page"
                                v-model="table.currentPage"
                                @input="filterReceipts()" />
                </nav>
              </b-col>          
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <!--
      ###########################
      ######### PRINTER #########
      ###########################
      -->
      <Printer v-if="crud.print.id" 
              :reference="crud.print.reference" 
              :registerID="crud.print.id"
              :key="crud.print.key"/>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close      
              header-bg-variant="dark"
              header-text-variant="white"
              size="xl">
        <div slot="modal-header">
          {{this.modal.form.title}}
        </div>

        <form-wizard  title=""
                      subtitle=""
                      nextButtonText="Siguiente"
                      backButtonText="Atrás"
                      finishButtonText="Guardar"
                      color="#2f353a"
                      shape="tab"
                      @on-complete="save"
                      class="crud-receipts-wizard">

          <tab-content title="General" icon="fa fa-edit" :before-change="receiptsValidGeneral">          
            <b-row>      
              <b-col md="4">
                <b-form-group label="Fecha">
                  <b-form-datepicker size="sm" v-model="crud.form.date" placeholder="Fecha" local="es"></b-form-datepicker>                      
                </b-form-group>            
              </b-col>
            </b-row>              
            <b-row> 
              <b-col md="5">
                <FindObject render="search"
                            type="customers" 
                            @select-object="loadCustomers($event)" 
                            :valueID="crud.form.customers_id"
                            :where="conditionCustomersActive"
                            :disabled="crud.form.id>0" />                 
              </b-col>    
              <b-col md="3">
                <FindObject render="search"
                            type="erpPointsSales" 
                            display="full_identification"
                            @select-object="loadPointsSales($event)" 
                            :valueID="crud.form.points_sales_id"
                            :key="crud.form.points_sales_id"
                            :disabled="crud.form.id>0"  />                 
              </b-col>              
            </b-row>
            <b-row v-if="balanceCurrentAccount<0">
              <b-col>
                <b-alert show variant="danger">
                  Se encontró saldo a favor del cliente: <b>({{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(balanceCurrentAccount)}})</b>
                </b-alert>
              </b-col>
            </b-row>
          </tab-content>
          
          <tab-content title="Imputación" icon="fa fa-paperclip" :before-change="receiptsValidImputation">                                  
            <b-row>
              <b-col lg="12" md="12" sm="12">
                <b-table-simple hover small caption-top responsive v-if="arr.pending.length" class="crud-receipts-table-items">
                  <b-thead head-variant="dark">                    
                    <b-tr>
                      <b-th width="10%" class="text-left">Imputar</b-th>
                      <b-th width="15%" class="text-left">Fecha</b-th>
                      <b-th width="40%" class="text-left">Comprobante</b-th>                      
                      <b-th width="10%" class="text-right">Total</b-th>
                      <b-th width="10%" class="text-right">Pendiente</b-th>
                      <b-th width="15%" class="text-center">A Imputar</b-th>                                            
                    </b-tr>
                  </b-thead>      
                  <b-tbody v-for="(item, index) in arr.pending" :key="item.id">                         
                    <b-tr :key="itemForceUpdate" v-if="crud.formPending[index]">
                      <b-td class="text-left align-middler">
                        <b-form-checkbox v-model="crud.formPending[index].check" 
                                          @change="validCheck(index)"
                                          switch 
                                          size="sm" 
                                          class="pull-left">
                        </b-form-checkbox> 
                      </b-td>
                      <b-td class="text-left align-middle">
                        {{moment(item.date).format('DD/MM/YYYY')}}
                      </b-td>
                      <b-td class="text-left align-middle">                        
                        {{item.type_voucher.name + ' ' + item.point_sale.point_sale.toString().padStart(4,'0') + '-' + item.number.toString().padStart(8,'0')}}
                      </b-td>
                      <b-td class="text-right align-middle">
                        <div style="color:red;" v-if="item.type_voucher.type_balance == '-'">
                          <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item.amount_total)}}</b>
                        </div>
                        <div style="color:green;" v-else>
                          <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item.amount_total)}}</b>
                        </div>
                      </b-td>                      
                      <b-td class="text-right align-middle">
                        <div style="color:red;" v-if="item.type_voucher.type_balance == '-'">
                          <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(calcVoucherPending(item))}}</b>
                        </div>
                        <div style="color:green;" v-else>
                          <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(calcVoucherPending(item))}}</b>
                        </div>                        
                      </b-td>                      
                      <b-td class="text-center align-middle">
                        <b-form-input type="number"
                                      size="sm"
                                      step="0.01"
                                      min="0"                                      
                                      @change="validAmount(index)"
                                      v-model="crud.formPending[index].amount"                                      
                                      placeholder="Ingresar monto a imputar"
                                      class="crud-receipts-item-input"
                                      v-if="crud.formPending[index].check">
                        </b-form-input>                        
                      </b-td>                      
                    </b-tr>                    
                  </b-tbody>                              
                </b-table-simple>   
                <div v-else>
                  <b-alert show variant="warning">
                    No hay comprobante para imputar.
                  </b-alert>                
                </div>
              </b-col> 
            </b-row>            
            <b-row align-h="end" class="mb-2">
              <b-col lg="4" md="4" sm="4">
                <b-input-group size="sm" prepend="TOTAL A IMPUTAR">
                  <b-form-input v-model="calc.imputation" 
                                type="text"
                                :readonly="true"
                                class="receipts-payments-add-total-final">
                  </b-form-input>   
                </b-input-group>                
              </b-col>
            </b-row>                        
          </tab-content>

          <tab-content title="Detalle" icon="fa fa-list" :before-change="receiptsValidPayments">
            <b-row align-h="center"> 
              <b-col lg="4">             
                <FinanceADD @getFinances="storeFinances($event)" 
                            v-if="crud.form.customers_id && crud.form.points_sales_id"
                            :points_sales="crud.form.points_sales"
                            :amount_impute="calc.imputation"
                            :reset="resetControl"/>              
              </b-col>
            </b-row>
          </tab-content>

          <tab-content title="Asiento Contable" icon="fa fa-balance-scale" :before-change="receiptsValidCrudAccounting" v-if="showContabilidad"> 
            <div v-if="contabilidad.render" :key="'accounting_' + itemAccountingForceUpdate">
              <AccountingEntries  :typeDebe="contabilidad.typeDebe"
                                  :typeHaber="contabilidad.typeHaber"
                                  :defaultDebe="contabilidad.defaultDebe"
                                  :defaultHaber="contabilidad.defaultHaber"
                                  :reference="contabilidad.reference"
                                  :amountTotal="contabilidad.amountTotal"
                                  @getAsiento="getAsiento($event)" />         
            </div>
          </tab-content>          

          <tab-content title="Observaciones" icon="fa fa-flag-checkered">          
            <b-row>
              <b-col md="12">
                <b-form-group label="Observaciones">
                  <b-form-textarea                
                    v-model="crud.form.observations"
                    placeholder="Ingresar las observaciones..."
                    rows="3"
                    max-rows="6"
                    lazy
                  ></b-form-textarea>
                </b-form-group>
              </b-col>         
            </b-row>
            <b-row v-if="crud.form.payment">
              <b-col>
                <b-alert show variant="warning" v-if="parseFloat(crud.form.payment.total) > parseFloat(calc.imputation)">
                  El importe recibido es mayor al total de los comprobantes imputado.<br>
                  <b>Importe Imputado</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(this.calc.imputation)}}<br>
                  <b>Importe Recibido</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(this.crud.form.payment.total)}}<br><br>
                  <i>El saldo quedará en cuenta corriente pendiente de imputación a favor del cliente</i>
                </b-alert>
              </b-col>
            </b-row>              
          </tab-content>

        </form-wizard>
        
        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="cancel()">Cancelar</b-button>              
        </div>                
      </b-modal>

      <!-- CRUD DISCOUNT -->
      <b-modal v-model="modal.discounts.active"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close      
              header-bg-variant="dark"
              header-text-variant="white"
              size="xl">
        <div slot="modal-header">
          {{this.modal.discounts.title}}
        </div>

        <form-wizard  title=""
                      subtitle=""
                      nextButtonText="Siguiente"
                      backButtonText="Atrás"
                      finishButtonText="Guardar"
                      color="#2f353a"
                      shape="tab"
                      @on-complete="save"
                      class="crud-receipts-wizard">

          <tab-content title="General" icon="fa fa-edit" :before-change="receiptsValidGeneralDiscounts">          
            <b-row>      
              <b-col md="4">
                <b-form-group label="Fecha">
                  <b-form-datepicker size="sm" v-model="crud.form.date" placeholder="Fecha" local="es"></b-form-datepicker>                      
                </b-form-group>            
              </b-col>
            </b-row>              
            <b-row> 
              <b-col md="5">
                <FindObject render="search"
                            type="customers" 
                            @select-object="loadCustomers($event)" 
                            :valueID="crud.form.customers_id"
                            :where="conditionCustomersActive"
                            :disabled="crud.form.id>0" />                 
              </b-col>    
              <b-col md="3">
                <FindObject render="search"
                            type="erpPointsSales" 
                            display="full_identification"
                            @select-object="loadPointsSales($event)" 
                            :valueID="crud.form.points_sales_id"
                            :key="crud.form.points_sales_id"
                            :disabled="crud.form.id>0"  />                 
              </b-col>       
              <b-col md="4">
                <FindObject render="search"
                            type="concepts"                             
                            @select-object="loadConcepts($event)" 
                            :valueID="crud.form.concepts_id"
                            :key="crud.form.points_sales_id"
                            :disabled="crud.form.id>0" />           
              </b-col>                          
            </b-row>
            <b-row v-if="balanceCurrentAccount<0">
              <b-col>
                <b-alert show variant="danger">
                  Se encontró saldo a favor del cliente: <b>({{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(balanceCurrentAccount)}})</b>
                </b-alert>
              </b-col>
            </b-row>
          </tab-content>
          
          <tab-content title="Imputación" icon="fa fa-paperclip" :before-change="receiptsValidImputation">                                  
            <b-row>
              <b-col lg="12" md="12" sm="12">
                <b-table-simple hover small caption-top responsive v-if="arr.pending.length" class="crud-receipts-table-items">
                  <b-thead head-variant="dark">                    
                    <b-tr>
                      <b-th width="5%" class="text-left">Imputar</b-th>
                      <b-th width="10%" class="text-left">Fecha</b-th>
                      <b-th width="20%" class="text-left">Comprobante</b-th>                      
                      <b-th width="10%" class="text-right">Total</b-th>
                      <b-th width="10%" class="text-right">Pendiente</b-th>
                      <b-th width="10%" class="text-center">Desc (%)</b-th>
                      <b-th width="10%" class="text-right">Desc ($)</b-th>
                      <b-th width="10%" class="text-right">Pend.Final</b-th>
                      <b-th width="15%" class="text-center">A Imputar</b-th>                                            
                    </b-tr>
                  </b-thead>      
                  <b-tbody v-for="(item, index) in arr.pending" :key="item.id">                         
                    <b-tr :key="itemForceUpdate" v-if="crud.formPending[index]">
                      <b-td class="text-left align-middler">
                        <b-form-checkbox v-model="crud.formPending[index].check" 
                                          @change="validCheck(index)"
                                          switch 
                                          size="sm" 
                                          class="pull-left">
                        </b-form-checkbox> 
                      </b-td>
                      <b-td class="text-left align-middle">
                        {{moment(item.date).format('DD/MM/YYYY')}}
                      </b-td>
                      <b-td class="text-left align-middle">                        
                        {{item.type_voucher.name + ' ' + item.point_sale.point_sale.toString().padStart(4,'0') + '-' + item.number.toString().padStart(8,'0')}}
                      </b-td>
                      <b-td class="text-right align-middle">
                        <div style="color:red;" v-if="item.type_voucher.type_balance == '-'">
                          <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item.amount_total)}}</b>
                        </div>
                        <div style="color:green;" v-else>
                          <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item.amount_total)}}</b>
                        </div>
                      </b-td>                      
                      <b-td class="text-right align-middle">
                        <div style="color:red;" v-if="item.type_voucher.type_balance == '-'">
                          <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(calcVoucherPending(item))}}</b>
                        </div>
                        <div style="color:green;" v-else>
                          <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(calcVoucherPending(item))}}</b>
                        </div>                        
                      </b-td>   
                      <b-td class="text-center align-middle">
                        <b-form-input type="number"
                                      size="sm"
                                      step="0.01"
                                      min="0"                                      
                                      max="100"                                      
                                      @change="validDiscounts(index)"
                                      v-model="crud.formPending[index].discounts"                                      
                                      placeholder="Ingresar descuento"
                                      class="crud-receipts-item-input"
                                      v-if="crud.formPending[index].check">
                        </b-form-input>                        
                      </b-td> 
                      <b-td class="text-right align-middle">
                        <div style="color:red;" v-if="item.type_voucher.type_balance == '-'">
                          <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(crud.formPending[index].amount_discounts)}}</b>
                        </div>
                        <div style="color:green;" v-else>
                          <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(crud.formPending[index].amount_discounts)}}</b>
                        </div>                        
                      </b-td>                            
                      <b-td class="text-right align-middle">
                        <div style="color:red;" v-if="item.type_voucher.type_balance == '-'">
                          <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(crud.formPending[index].amount_result)}}</b>
                        </div>
                        <div style="color:green;" v-else>
                          <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(crud.formPending[index].amount_result)}}</b>
                        </div>                        
                      </b-td>                                                                  
                      <b-td class="text-center align-middle">
                        <b-form-input type="number"
                                      size="sm"
                                      step="0.01"
                                      min="0"                                      
                                      @change="validAmount(index)"
                                      v-model="crud.formPending[index].amount"                                      
                                      placeholder="Ingresar monto a imputar"
                                      class="crud-receipts-item-input"
                                      v-if="crud.formPending[index].check">
                        </b-form-input>                        
                      </b-td>                      
                    </b-tr>                    
                  </b-tbody>                              
                </b-table-simple>   
                <div v-else>
                  <b-alert show variant="warning">
                    No hay comprobante para imputar.
                  </b-alert>                
                </div>
              </b-col> 
            </b-row>            
            <b-row align-h="end" class="mb-2">
              <b-col lg="4" md="4" sm="4">
                <b-input-group size="sm" prepend="TOTAL A IMPUTAR">
                  <b-form-input v-model="calc.imputation" 
                                type="text"
                                :readonly="true"
                                class="receipts-payments-add-total-final">
                  </b-form-input>   
                </b-input-group>                
              </b-col>
            </b-row>                        
          </tab-content>

          <tab-content title="Detalle" icon="fa fa-list" :before-change="receiptsValidPayments">
            <b-row align-h="center"> 
              <b-col lg="4">             
                <FinanceADD @getFinances="storeFinances($event)" 
                            v-if="crud.form.customers_id && crud.form.points_sales_id"
                            :points_sales="crud.form.points_sales"
                            :amount_impute="calc.imputation"
                            :reset="resetControl"/>              
              </b-col>
            </b-row>
          </tab-content>

          <tab-content title="Asiento Contable" icon="fa fa-balance-scale" :before-change="receiptsValidCrudAccounting" v-if="showContabilidad"> 
            <div v-if="contabilidad.render" :key="'accounting_' + itemAccountingForceUpdate">
              <AccountingEntries  :typeDebe="contabilidad.typeDebe"
                                  :typeHaber="contabilidad.typeHaber"
                                  :defaultDebe="contabilidad.defaultDebe"
                                  :defaultHaber="contabilidad.defaultHaber"
                                  :reference="contabilidad.reference"
                                  :amountTotal="contabilidad.amountTotal"
                                  @getAsiento="getAsiento($event)" />         
            </div>              
            <div v-if="contabilidadNC.render" :key="'accountingNC_' + itemAccountingForceUpdate">
              <AccountingEntries  :typeDebe="contabilidadNC.typeDebe"
                                  :typeHaber="contabilidadNC.typeHaber"
                                  :defaultDebe="contabilidadNC.defaultDebe"
                                  :defaultHaber="contabilidadNC.defaultHaber"
                                  :reference="contabilidadNC.reference"
                                  :amountTotal="contabilidadNC.amountTotal"
                                  @getAsiento="getAsientoNC($event)" />         
            </div>                
          </tab-content>          

          <tab-content title="Observaciones" icon="fa fa-flag-checkered">          
            <b-row>
              <b-col md="12">
                <b-form-group label="Observaciones">
                  <b-form-textarea                
                    v-model="crud.form.observations"
                    placeholder="Ingresar las observaciones..."
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>         
            </b-row>
            <b-row v-if="crud.form.payment">
              <b-col>
                <b-alert show variant="warning" v-if="parseFloat(crud.form.payment.total) > parseFloat(calc.imputation)">
                  El importe recibido es mayor al total de los comprobantes imputado.<br>
                  <b>Importe Imputado</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(this.calc.imputation)}}<br>
                  <b>Importe Recibido</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(this.crud.form.payment.total)}}<br><br>
                  <i>El saldo quedará en cuenta corriente pendiente de imputación a favor del cliente</i>
                </b-alert>
              </b-col>
            </b-row>              
          </tab-content>

        </form-wizard>
        
        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="cancel()">Cancelar</b-button>              
        </div>                
      </b-modal>

      <!-- CRUD DETAILS -->
      <b-modal v-model="modal.detail.active"
              header-bg-variant="dark"
              header-text-variant="white"
              size="xl">
        <div slot="modal-header">
          {{this.modal.detail.title}}
        </div>

        <b-row>
          <b-col sm="12">                     
            <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark">
              <b-tab title="General">
                <table class="table table-hover table-sm" v-if="itemSelected">
                  <tbody>
                    <tr>
                      <td class="crud-receipts-title-table-custom align-middle">ID</td>
                      <td class="crud-receipts-value-table-custom align-middle">
                        <b>#{{this.itemSelected.id}}</b>
                      </td>
                    </tr>                  
                    <tr>
                      <td class="crud-receipts-title-table-custom align-middle">Empresa</td>
                      <td class="crud-receipts-value-table-custom align-middle">
                        {{this.itemSelected.point_sale.business.reference}}
                      </td>
                    </tr>                       
                    <tr v-if="itemSelected.type_voucher && itemSelected.point_sale">
                      <td class="crud-receipts-title-table-custom align-middle">Comprobante</td>                      
                      <td class="crud-receipts-value-table-custom align-middle">
                        <b>{{this.itemSelected.type_voucher.name + ' '  + this.itemSelected.point_sale.point_sale.toString().padStart(4,'0') + '-' + this.itemSelected.number.toString().padStart(8,'0')}}</b>
                      </td>
                    </tr>                                                           
                    <tr v-if="itemSelected.staff">
                      <td class="crud-receipts-title-table-custom align-middle">Emisor</td>                      
                      <td class="crud-receipts-value-table-custom align-middle">
                        <div v-if="itemSelected.staff">
                          {{itemSelected.staff.name}}
                        </div> 
                      </td>
                    </tr>                                                             
                    <tr>
                      <td class="crud-receipts-title-table-custom align-middle">Fecha</td>
                      <td class="crud-receipts-value-table-custom align-middle">
                        {{moment(this.itemSelected.date).format('DD MMMM YYYY')}}
                      </td>
                    </tr>                                          
                    <tr v-if="itemSelected.point_sale">
                      <td class="crud-receipts-title-table-custom align-middle">Punto de Venta</td>
                      <td class="crud-receipts-value-table-custom align-middle">
                        {{this.itemSelected.point_sale.point_sale}} - {{this.itemSelected.point_sale.name}}                          
                      </td>
                    </tr>                                           
                    <tr v-if="itemSelected.customer">
                      <td class="crud-receipts-title-table-custom align-middle">Cliente</td>
                      <td class="crud-receipts-value-table-custom align-middle">
                        {{this.itemSelected.customer.name}}                        
                      </td>
                    </tr>                        
                    <tr v-if="itemSelected.amount_total">
                      <td class="crud-receipts-title-table-custom align-middle">Total</td>
                      <td class="crud-receipts-value-table-custom align-middle">    
                        <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.getCurrencyCode}).format(this.itemSelected.amount_total)}}</b>                        
                      </td>
                    </tr>                         
                    <tr v-if="itemSelected.observations">
                      <td class="crud-receipts-title-table-custom align-middle">Observaciones</td>
                      <td class="crud-receipts-value-table-custom align-middle">                        
                        {{this.itemSelected.observations}}
                      </td>
                    </tr>                         
                    <tr v-if="itemSelected.amount_pending">
                      <td class="crud-receipts-title-table-custom align-middle">Pendiente de Imputación</td>
                      <td class="crud-receipts-value-table-custom align-middle table-warning">    
                        <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.getCurrencyCode}).format(this.itemSelected.amount_pending)}}</b>                        
                      </td>
                    </tr> 
                    <tr v-if="itemSelected.sales_nc_discounts_id && itemSelected.sales_discounts_trashed.type_voucher && itemSelected.sales_discounts_trashed.point_sale">
                      <td class="crud-receipts-title-table-custom align-middle">Descuento Aplicado</td>                      
                      <td class="crud-receipts-value-table-custom align-middle table-info">
                        {{this.itemSelected.sales_discounts_trashed.type_voucher.name + ' '  + this.itemSelected.sales_discounts_trashed.point_sale.point_sale.toString().padStart(4,'0') + '-' + this.itemSelected.sales_discounts_trashed.number.toString().padStart(8,'0')}}
                      </td>
                    </tr>                                                                                              
                  </tbody>
                </table>
              </b-tab>              
              <b-tab title="Detalle de Pago">                
                <b-table class="mb-0 table-full-detail-receipts"
                        responsive
                        head-variant="dark"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="tableDetailPayment.items"
                        :fields="tableDetailPayment.fields"
                        v-if="tableDetailPayment.items.length">                       
                    
                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"                    
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template>           

                  <template v-slot:cell(medio)="row"> 
                    <div v-if="row.item.type=='CASH'">
                      EFECTIVO            
                    </div>
                    <div v-if="row.item.type=='CHEQUE'">
                      CHEQUE
                    </div>
                  </template>

                  <template v-slot:cell(description)="row"> 
                    <div v-if="row.item.type=='CASH'">
                      <b>CAJA:</b> {{row.item.relation_trashed.cash.name}} |
                      <b>MONEDA:</b> {{row.item.relation_trashed.currency.name}}
                    </div>
                    <div v-if="row.item.type=='CHEQUE'">
                      <b>ID:</b> {{row.item.relation_trashed.id}} |
                      <b>NUMERO:</b> {{row.item.relation_trashed.number}} |
                      <b>BANCO:</b> {{row.item.relation_trashed.bank}} |
                      <b>EMISION:</b> {{moment(row.item.relation_trashed.date).format('DD/MM/YYYY')}} |
                      <b>VENCIMIENTO:</b> {{moment(row.item.relation_trashed.date_expiration).format('DD/MM/YYYY')}} |
                      <b-link :id="'more-data-cheque-' + row.index">Más Datos ...</b-link>

                      <b-popover :target="'more-data-cheque-' + row.index" triggers="hover" placements="auto">
                        <template #title>Datos Cheque</template>
                        <b>ID:</b> {{row.item.relation_trashed.id}} <br>
                        <b>NUMERO:</b> {{row.item.relation_trashed.number}} <br>
                        <b>BANCO:</b> {{row.item.relation_trashed.bank}} <br>
                        <b>EMISION:</b> {{moment(row.item.relation_trashed.date).format('DD/MM/YYYY')}} <br>
                        <b>VENCIMIENTO:</b> {{moment(row.item.relation_trashed.date_expiration).format('DD/MM/YYYY')}} <br>
                        <b>EMISOR:</b> {{row.item.relation_trashed.transmitter_name}} <br>
                        <b>CUIT:</b> {{row.item.relation_trashed.transmitter_documents_number}} <br>
                        <b>OBSERVACIONES:</b> {{row.item.relation_trashed.observations}}
                      </b-popover>                      
                    </div>
                  </template>                  

                  <template v-slot:cell(amount)="row">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(row.item.amount_total)}}
                  </template>                  
                  
                </b-table>
                <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
              </b-tab>
              <b-tab title="Comprobantes Imputados">                
                <b-table class="mb-0 table-full-detail-receipts"
                        responsive
                        head-variant="dark"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="tableDetailImputation.items"
                        :fields="tableDetailImputation.fields"
                        v-if="tableDetailImputation.items.length">                       
                    
                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"                    
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template>           

                  <template v-slot:cell(date)="row"> 
                    {{moment(row.item.sales.date).format('DD/MM/YYYY')}}
                  </template>

                  <template v-slot:cell(voucher)="row"> 
                    {{row.item.sales.type_voucher.name + ' ' + row.item.sales.point_sale.point_sale.toString().padStart(4,'0') + '-' + row.item.sales.number.toString().padStart(8,'0')}}
                  </template>

                  <template v-slot:cell(amount_total)="row">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(row.item.sales.amount_total)}}
                  </template>               

                  <template v-slot:cell(amount_pending)="row">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(calcPendingVoucher(row.item))}}
                  </template>                                 

                  <template v-slot:cell(amount_discount)="row">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(row.item.discount_amount_nc)}}
                    ({{Intl.NumberFormat('es-AR',{style:'percent', maximumFractionDigits: 2}).format(row.item.discount_percentage_nc/100)}})
                  </template>                                 

                  <template v-slot:cell(amount_impute)="row">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(row.item.amount_total)}}
                  </template>                                 
                </b-table>
                <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
              </b-tab>   
              <b-tab title="Asiento" v-if="showContabilidad">
                <b-table class="mb-0 table-full-detail-sales"
                        responsive
                        head-variant="dark"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="tableAccounting.items"
                        :fields="tableAccounting.fields"
                        v-if="tableAccounting.items.length">                       
                    
                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"                    
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template>                                                                                     

                  <template v-slot:cell(code)="data">
                    <div v-if="data.item.type=='Debe'">
                      <span>{{data.item.accounting_accounts_code}}</span>
                    </div>
                    <div v-if="data.item.type=='Haber'">
                      <span class="ml-5">{{data.item.accounting_accounts_code}}</span>
                    </div>
                  </template>  

                  <template v-slot:cell(name)="data">
                    <div v-if="data.item.type=='Debe'">
                      <span>{{data.item.accounting_accounts_name}}</span>
                    </div>
                    <div v-if="data.item.type=='Haber'">
                      <span class="ml-5">{{data.item.accounting_accounts_name}}</span>
                    </div>                                                          
                  </template>

                  <template v-slot:cell(debit)="data">
                    <span v-if="data.item.type == 'Debe'">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(data.item.total)}}
                    </span>
                  </template>

                  <template v-slot:cell(credit)="data">
                    <span v-if="data.item.type == 'Haber'">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(data.item.total)}}
                    </span>
                  </template>
                </b-table>
                <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
              </b-tab>                         
            </b-tabs>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.detail.active=false">Cancelar</b-button>                   
        </div>
      </b-modal>

    </b-col>
  </b-row>
</template>

<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import ErrorToken from '@/handler/errorToken'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import Param from '@/config/parameters'
  import FindObject from '@/components/inc/find/findObject'    
  import Printer from '@/components/inc/printer/printer'  
  import AccountingEntries from '@/components/inc/accounting/entries'  
  import moment from 'moment'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import FinanceADD from '@/components/inc/finances/add'  

  export default {
    components: {
      FindObject,
      Printer,      
      FormWizard,
      TabContent,    
      FinanceADD,  
      AccountingEntries,
    },
    data: () => {
      return {      
        access: {
          module_id: Modules.RECIBOS_ERP,
          profile_id: Profiles.PERSONAL,
          view_reference: 'receiptsTrashed',
          elements: {
            approvalReceiptsTrashed: true,
            disapproveReceiptsTrashed: true,
          }
        },
        table : {
          items: [],
          fields: [],
          filter: null,
          mostrarFiltros: true,
          currentPage: 1,
          perPage: 0,
          isBusy: false,
          tablePaginate: null,          
        },     
        tableSubPayment : {
          items: [],
          fields: []
        },            
        tableSubImputation : {
          items: [],
          fields: []
        },                    
        tableDetailPayment : {
          items: [],
          fields: []
        },       
        tableAccounting : {
          items: [],
          fields: []
        },        
        tableDetailImputation : {
          items: [],
          fields: []
        },                    
        crud: {
          form: {
            id: 0,
            date: '',            
            types_vouchers_id: 0,
            types_vouchers: null,
            letter: '',
            number: 0,
            points_sales_id: 0,
            points_sales: null,              
            observations: '',            
            staff_id: 0,
            customers_id: 0,
            customers: null,  
            accountingEntry: null,  
            accountingEntryNC: null,  
            selectTypeVoucher: 'recibo',
            selectDestination: 'default',            
            reference_voucher_id: 0,                                                           
            payment: null,
            imputation: [],    
            operation: 'add',
            concepts: null,
            concepts_id: 0,            
            trashed: true,
          },                        
          formPending: [],       
          print: {
            reference: '',
            id: 0,
            key: 0,
          }               
        },
        modal: {
          form: {
            active: false,
            title: '',
          },
          imputation: {
            active: false,
            title: '',
          },
          detail: {
            active: false, 
            title: '',
          },        
          discounts: {
            active: false, 
            title: '',            
          }                
        },          
        arr: {
          receipts: [],  
          pending: [],
          export: [],           
          filters : {
            customers: [],            
            points_sales: [],            
          },                              
        },           
        filters: {
          date_start: '',
          date_end: '',
          customers: null,
          points_sales: null,
        },     
        itemSelected: null,             
        itemForceUpdate: 0,
        resetControl: false,
        calc: {
          imputation: 0,
          discounts: 0,
          discountsIva: 0,
          positiveBalance: 0,
        },        
        itemAccountingForceUpdate: 0,    
        contabilidad: {
          render: false,
          typeDebe:"",                                 
          typeHaber:"",
          defaultDebe:[],
          defaultHaber:[],
          reference:'',
          amountTotal:0
        },    
        contabilidadNC: {
          render: false,
          typeDebe:"",                                 
          typeHaber:"",
          defaultDebe:[],
          defaultHaber:[],
          reference:'',
          amountTotal:0
        },             
        balanceCurrentAccount: 0,   
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      this.access.elements.approvalReceiptsTrashed = Helper.hasAccessElement(this.access, 'approval_receiptsTrashed')
      this.access.elements.disapproveReceiptsTrashed = Helper.hasAccessElement(this.access, 'disapprove_receiptsTrashed')
      /* Fin configuracion */
    },     
    mounted() {   
      this.loadFieldTable()
      this.filterLoad()   
      this.filterReceipts()              
      this.loadStyleConfig()
    },    
    computed: {      
      // CONDITIONS SELECT
      conditionCustomersActive(){
        return [{field: 'active', condition: true}];
      },  

      // CURRENCY
      getCurrencySymbol() {
        return '$'
      },  
      getCurrencyCode() {
        return 'ARS'
      },  

      // IMPUTATION
      getImputation() {
        var imputation = 0
        if(this.crud.form.payment) {
          if(this.crud.formPending) {                        
            this.crud.formPending.forEach(element => {                             
              if(element.check) {    
                if(element.operation == '+') {
                  imputation = parseFloat(imputation) + parseFloat(element.amount)
                } else {
                  imputation = parseFloat(imputation) - parseFloat(element.amount)
                }
              }
            });   
          }
        }
        return imputation        
      },

      // CONFIGURACION
      showContabilidad() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules        
        modules.forEach(element => {
          if(element.id == Modules.CONTABILIDAD) {                             
            status = true                       
          }
        })        
        return status
      }, 
      
      // VOUCHER
      getRefVoucher() {        
        if(this.crud.form.types_vouchers && this.crud.form.points_sales && this.crud.form.number) {
          return this.crud.form.types_vouchers.name + ' '  + this.crud.form.points_sales.point_sale.toString().padStart(4,'0') + '-' + this.crud.form.number.toString().padStart(8,'0')  
        } else {
          return ''
        }      
      },      
    },    
    watch: {        
      'crud.form.customers_id': function (newQuestion, oldQuestion) {         
        if(this.crud.form.operation == 'add') {
          this.crud.form.payment = null           
          this.crud.form.imputation = []                    
          this.resetControl = true

          this.arr.pending = []          
          this.crud.formPending = []
          this.calc.imputation = 0
          this.calc.discounts = 0
          this.calc.discountsIva = 0
          this.balanceCurrentAccount = 0          
          
          this.obtenerVouchersPendingImputarByCustomers()
          this.searchVoucherByCustomer()
        }
      },
      'crud.form.points_sales_id': function (newQuestion, oldQuestion) {                
        if(this.crud.form.operation == 'add') {
          this.crud.form.payment = null           
          this.crud.form.imputation = []          
          this.resetControl = true

          this.arr.pending = []
          this.crud.formPending = []
          this.calc.imputation = 0
          this.calc.discounts = 0
          this.calc.discountsIva = 0          
          this.balanceCurrentAccount = 0

          this.obtenerVouchersPendingImputarByCustomers()        
          this.searchVoucherByCustomer()
        }
      },
      'crud.form.concepts_id': function (newQuestion, oldQuestion) {                        
        if(this.crud.form.selectDestination == 'discounts') {
          if(this.crud.form.operation == 'add') {
            this.crud.form.payment = null           
            this.crud.form.imputation = []          
            this.resetControl = true

            this.arr.pending = []
            this.crud.formPending = []
            this.calc.imputation = 0
            this.calc.discounts = 0
            this.calc.discountsIva = 0          
            this.balanceCurrentAccount = 0

            this.obtenerVouchersPendingImputarByCustomers()        
            this.searchVoucherByCustomer()
          }
        } 
      },        
    },    
    methods: {
      // CONFIGURACION
      loadStyleConfig () {        
        var view_list_receipts = document.getElementById('view_list_receipts')
        var view_footer_receipts = document.getElementById('view_footer_receipts')

        var padre = document.getElementById('contain_details_items')
        var hijo = document.getElementById('details_items')  
            
        hijo.style.width = padre.clientWidth - 45 + 'px'

        if(window.innerWidth < 991) {
          hijo.style.width = '100%'
          hijo.style.position = "relative"
          hijo.style.right = 'auto'

          view_list_receipts.classList.remove('pr-0')
          view_footer_receipts.classList.remove('pr-0')
        } else {          
          view_list_receipts.classList.add('pr-0')
          view_footer_receipts.classList.add('pr-0')
        }        
      },
      loadFieldTable (openDiscount=false) {
        // TABLE COMPROBANTES
        this.table.fields = []
        this.table.fields.push({key: 'business', label: 'Empresa', class:"align-middle text-left", width:"60px"})
        this.table.fields.push({key: 'id', label: 'Nº', sortable: true, class:"align-middle text-center", width:"120px"})
        this.table.fields.push({key: 'date', label: 'Fecha', class:"align-middle text-center", width:"80px"})                
        this.table.fields.push({key: 'customers_id', label: 'Cliente', class:"align-middle", width:"200px"})                      
        this.table.fields.push({key: 'staff_id', label: 'Staff', class:"align-middle text-center", width:"60px"})        
        this.table.fields.push({key: 'amount_total', label: 'Total', class:"align-middle text-right", width:"60px"})        
        this.table.fields.push({key: 'amount_pending', label: 'Imputar', class:"align-middle text-right", width:"60px"})        
        this.table.fields.push({key: 'observations', label: '', class:"align-middle text-center", width:"25px"})                        
        this.table.fields.push({key: 'f_action', label:'', class:"align-middle", width:"60px"})

        // TABLE DETALLE
        this.tableSubPayment.fields = []
        this.tableSubPayment.fields.push({key: 'medio', label: 'Medio', class:"align-middle text-left text-truncate", width:"45%"})
        this.tableSubPayment.fields.push({key: 'amount', label: 'Importe', class:"align-middle text-right", width:"30%"})        

        // TABLE IMPUTATION
        this.tableSubImputation.fields = []
        this.tableSubImputation.fields.push({key: 'voucher', label: 'Comprobante', class:"align-middle text-left text-truncate", width:"45%"})
        this.tableSubImputation.fields.push({key: 'amount', label: 'Importe', class:"align-middle text-right", width:"30%"})

        // TABLE DETALLE COMPLETO        
        this.tableDetailPayment.fields = []
        this.tableDetailPayment.fields.push({key: 'medio', label: 'Medio', class:"align-middle text-left text-truncate", width:"20%"})                
        this.tableDetailPayment.fields.push({key: 'description', label: 'Detalle', class:"align-middle text-left text-truncate", width:"60%"})                
        this.tableDetailPayment.fields.push({key: 'amount', label: 'Importe', class:"align-middle text-right", width:"20%"})        

        // TABLE ASIENTO
        this.tableAccounting.fields = []
        this.tableAccounting.fields.push({key: 'code', label: 'Código', class:"align-middle", width:"150px"})                
        this.tableAccounting.fields.push({key: 'name', label: 'Nombre', class:"align-middle", width:"250px"})                
        this.tableAccounting.fields.push({key: 'debit', label: 'Debe', class:"align-middle", width:"150px"})                
        this.tableAccounting.fields.push({key: 'credit', label: 'Haber', class:"align-middle", width:"150px"})

        // TABLE DETALLE DE IMPUTATION
        this.tableDetailImputation.fields = []
        this.tableDetailImputation.fields.push({key: 'date', label: 'Fecha', class:"align-middle text-center", width:"10%"})
        this.tableDetailImputation.fields.push({key: 'voucher', label: 'Comprobante', class:"align-middle text-left text-truncate", width:"30%"})
        this.tableDetailImputation.fields.push({key: 'amount_total', label: 'Importe Total', class:"align-middle text-right", width:"15%"})
        this.tableDetailImputation.fields.push({key: 'amount_pending', label: 'Importe Pendiente', class:"align-middle text-right", width:"15%"})

        if(openDiscount) {
          this.tableDetailImputation.fields.push({key: 'amount_discount', label: 'Descuento Aplicado', class:"align-middle text-right", width:"15%"})
        }
        
        this.tableDetailImputation.fields.push({key: 'amount_impute', label: 'Importe Imputado', class:"align-middle text-right", width:"15%"})                                              
      },      
      getRowCount(items) {
        return items.length
      },
      onRowSelected(item) {         
        this.arr.receipts.forEach((element, index) => {
          this.table.items[index]._showDetails = false
          if(item.length){
            if(element.id == item[0].id) {  
              this.openSub(element)                             
            }
          }
        })
      },   
      setConfigTableReceiptsShow() {
        var arrTable = document.getElementsByClassName('table-receipts-custom')
        var i = 0
        for(i=0; i<arrTable.length; i++) {          
          arrTable[i].style.minHeight = '150px'
        }        
      },
      setConfigTableReceiptsHide() {
        var arrTable = document.getElementsByClassName('table-receipts-custom')
        var i = 0
        for(i=0; i<arrTable.length; i++) {
          arrTable[i].style.minHeight = 'auto'
        }        
      },  
      setConfigTableSubShow() {
        var arrTable = document.getElementsByClassName('table-receipts-sub')
        var i = 0
        for(i=0; i<arrTable.length; i++) {
          arrTable[i].style.minHeight = '210px'
        }        
      },
      setConfigTableSubHide() {
        var arrTable = document.getElementsByClassName('table-receipts-sub')
        var i = 0
        for(i=0; i<arrTable.length; i++) {
          arrTable[i].style.minHeight = 'auto'
        }        
      },  

      // SELECT
      loadCustomers(object) {        
        if(object){
          this.crud.form.customers = object
          this.crud.form.customers_id = object.id   
          
          if(object.data_fiscal) {
            if(object.data_fiscal.points_sales_id) {
              if(!this.crud.form.points_sales_id) {
                this.crud.form.points_sales = object.data_fiscal.points_sales
                this.crud.form.points_sales_id = object.data_fiscal.points_sales_id
              }
            }
          }

          this.getBalanceCurrentAccount()
        } else {
          this.crud.form.customers = null
          this.crud.form.customers_id = 0

          this.balanceCurrentAccount = 0
        }
      }, 
      loadPointsSales(object) {                
        if(object){
          this.crud.form.points_sales = object
          this.crud.form.points_sales_id = object.id    
          
          this.getBalanceCurrentAccount()
        } else {
          this.crud.form.points_sales = null
          this.crud.form.points_sales_id = 0

          this.getBalanceCurrentAccount()
        }
      },
      loadConcepts(object) {
        if(object){
          this.crud.form.concepts = object
          this.crud.form.concepts_id = object.id             
        } else {
          this.crud.form.concepts = null
          this.crud.form.concepts_id = 0
        }
      },      
      prepareExport(data) {        
        this.arr.export = []
        data.forEach(element => {
            var businessID = 0
            var businessName = ""          
            var customersID = 0
            var customersCode = ""
            var customersName = ""
            var voucherReference = ""

            if(element.point_sale && element.point_sale.business) {
              businessID = element.point_sale.business.id            
              businessName = element.point_sale.business.reference
            }
            if(element.customer) {
              customersID = element.customer.id
              customersCode = element.customer.code
              customersName = element.customer.name            
            }
            if(element.type_voucher) {            
              voucherReference = element.type_voucher.name + ' ' + element.point_sale.point_sale.toString().padStart(4,'0') + '-' + element.number.toString().padStart(8,'0')
            }         

            this.arr.export.push({
              id: element.id,
              businessID: businessID,
              businessName: businessName,              
              date: element.date,      
              voucherReference: voucherReference,        
              customersID: customersID,
              customersCode: customersCode,
              customersName: customersName,                                 
              total: element.amount_total,            
              total_pending: element.amount_pending,            
              observations: element.observations,    
              payment_medio: '',
              payment_amount: 0,
              imputation_reference: '',
              imputation_amount: 0,
            })

            element.details_payments_trashed.forEach(element1 => {            
              this.arr.export.push({
                payment_medio: element1.type,
                payment_amount: element1.amount_total,
              })
            })

            element.details_imputations_trashed.forEach(element1 => {   
              var voucherReferenceImputation = ''
              if(element1.sales.type_voucher) {            
                voucherReferenceImputation = element1.sales.type_voucher.name + ' ' + element1.sales.point_sale.point_sale.toString().padStart(4,'0') + '-' + element1.sales.number.toString().padStart(8,'0')
              }         

              this.arr.export.push({
                imputation_reference: voucherReferenceImputation,
                imputation_amount: element1.amount_total,
              })
            })            
          });
      },

      // AMOUNT CURRENT ACCOUNT
      getBalanceCurrentAccount() {
        var result = serviceAPI.filtrarCurrentsAccountsBalance({
          customers_id: this.crud.form.customers_id,
          points_sales_id: this.crud.form.points_sales_id, 
        })

        result.then((response) => {
          var data = response.data
          this.balanceCurrentAccount = data
        })
      },

      // ABM MAIN
      add(type = 'factura', destination = 'default') {										
        this.crud.form.operation = 'add'

        this.crud.form.id = 0           
        this.crud.form.date = moment().format('YYYY-MM-DD')        
        this.crud.form.observations = ''
        this.crud.form.staff_id = Helper.getStaffId()
        this.crud.form.customers_id = 0
        this.crud.form.customers = null   
        this.crud.form.points_sales_id = 0
        this.crud.form.points_sales = null        
        this.crud.form.types_vouchers_id = 0
        this.crud.form.types_vouchers = null
        this.crud.form.letter = ''
        this.crud.form.number = 0
        this.crud.form.payment = null
        this.crud.form.imputation = []         
        this.crud.form.concepts_id = 0
        this.crud.form.concepts = null   

        this.crud.formPending = []
        this.arr.pending = []

        this.calc.imputation = 0
        this.calc.discounts = 0
        this.calc.discountsIva = 0          

        this.balanceCurrentAccount = 0

				if(type=='recibo' && destination=='default') {
          this.modal.form.title = "Nueva Recibo"
        }          

				if(type=='recibo' && destination=='discounts') {
          this.modal.discounts.title = "Nuevo Recibo con Nota de Crédito (Descuentos en Facturas)"          
        }

        this.crud.form.selectTypeVoucher = type
        this.crud.form.selectDestination = destination

        if(destination=='default') {
          this.modal.form.active = true
        }

        if(destination=='discounts') {
          this.modal.discounts.active = true                  
        }
      },                 
      save() {
        this.$bvModal.msgBoxConfirm('¿Desea continuar con la generación del Recibo?', {
          title: 'Generar Recibo',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'GENERAR',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: 'dark',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {          
            let loader = this.$loading.show();
              
            var result = serviceAPI.agregarRecibos(this.crud.form);
        
            result.then((response) => {                   
              var result1 = serviceAPI.eliminarRecibos(response.data.id);

              result1.then((response1) => {      
                this.modal.form.active = false 
                this.modal.discounts.active = false

                loader.hide()
                this.filterReceipts()
                this.$awn.success("Recibo creado con éxito");
              })                          
              .catch(error => {
                loader.hide()
                this.$awn.alert(Error.showError(error));
              })             
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })            
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })              
      },          
      cancel() {
        this.$bvModal.msgBoxConfirm('¿Desea cancelar el Recibo?', {
          title: 'Cancelar el Recibo',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {        
            this.modal.form.active = false
            this.modal.discounts.active = false
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })   
      },

      // FINANCES
      storeFinances(values) {
        this.crud.form.payment = values           
        this.crud.form.payment.totalFormat = Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrencyCode}).format(this.crud.form.payment.total)
        
        this.calc.positiveBalance = this.crud.form.payment.total 
        this.calc.positiveBalanceFormat = Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrencyCode}).format(this.calc.positiveBalance)             

        this.resetControl = false
      },

      // VALIDATION STEP
      receiptsValidGeneral() {
        if(this.crud.form.customers_id && this.crud.form.points_sales_id) {                            
          return true;
        } else {
          if(!this.crud.form.customers_id) {
            this.$awn.alert("No se cargó el cliente");
            return false;
          }
          if(!this.crud.form.points_sales_id) {
            this.$awn.alert("No se cargó el punto de venta");
            return false;
          }
        }        
      },
      receiptsValidImputation() {            
        this.loadFormImpuation()
        return true;        
      },              
      receiptsValidPayments() {
        if(this.crud.form.payment) {
          if(this.crud.form.payment.total>0) {
            if(this.crud.form.payment.total >= this.calc.imputation ) {
              this.getContabilidad()
              return true
            } else {
              this.$awn.alert("El total del recibo no puede ser menor al total imputado");
              return false;                                      
            }
          } else {
            this.$awn.alert("No se cargó ningún método de pago");
            return false;          
          }
        } else {
          this.$awn.alert("No se cargó ningún método de pago");
          return false;                    
        }
      },
      receiptsValidCrudAccounting() {                
        if(this.crud.form.accountingEntry) {
          return true
        } else {
          this.$awn.alert("Revisar el Asiento Contable");
          return false
        }
      },

      // VALID RECIBOS DESC (NC)
      receiptsValidGeneralDiscounts() {        
        if(this.crud.form.customers_id && this.crud.form.points_sales_id && this.crud.form.concepts_id) {
          return true;
        } else {
          if(!this.crud.form.customers_id) {
            this.$awn.alert("No se cargó el cliente");
            return false;
          }
          if(!this.crud.form.points_sales_id) {
            this.$awn.alert("No se cargó el punto de venta");
            return false;
          }                                
          if(!this.crud.form.concepts_id) {
            this.$awn.alert("No se cargó el concepto");
            return false;
          }                                          
        }        
      },            

      // IMPUTACION COMPROBANTES
      obtenerVouchersPendingImputarByCustomers() {
        this.crud.formPending = []
        
        if(this.crud.form.customers_id && this.crud.form.points_sales_id) {
          var result = serviceAPI.filtrarPendienteImputar({
            customers_id:this.crud.form.customers_id, 
            points_sales_id: this.crud.form.points_sales_id,
          })        
          result.then((response) => {
            var data = response.data    
            
            this.arr.pending = data   
            this.arr.pending.forEach(element => {      
              if(this.crud.form.selectDestination == 'discounts') {                       
                this.crud.formPending.push({              
                  check: false,
                  id: element.id,                 
                  discounts: 0,
                  amount_discounts: 0,
                  amount_discounts_iva: 0,
                  amount: 0,                
                  amount_result: parseFloat(element.amount_total) - parseFloat(element.amount_impute),                
                  amountPending: parseFloat(element.amount_total) - parseFloat(element.amount_impute),
                  amountNet: parseFloat(element.amount_net),
                  maxAmount: parseFloat(element.amount_total) - parseFloat(element.amount_impute),   
                  maxAmountPending: parseFloat(element.amount_total) - parseFloat(element.amount_impute),   
                  operation: element.type_voucher.type_balance,
                  voucher: element,                                
                })
              } else {
                this.crud.formPending.push({              
                  check: false,
                  id: element.id,                 
                  amount: parseFloat(element.amount_total) - parseFloat(element.amount_impute),
                  maxAmount: parseFloat(element.amount_total) - parseFloat(element.amount_impute),
                  operation: element.type_voucher.type_balance,                  
                })                
              }
            });
          })                   
        }
      },      
      calcVoucherPending(item) {
        return parseFloat(item.amount_total) - parseFloat(item.amount_impute)
      },     
      validCheck(index) {         
        if(this.crud.form.selectDestination == 'discounts') {            
          if(this.crud.formPending[index].check) {                    
            this.crud.formPending[index].discounts = 0
            this.crud.formPending[index].amount = parseFloat(this.crud.formPending[index].amountPending).toFixed(2)
            this.forceUpdateItem()
          } else {
            this.crud.formPending[index].discounts = 0
            this.crud.formPending[index].amount = 0
            this.forceUpdateItem()          
          }
        } else {
          if(this.crud.formPending[index].check) {                  
            this.crud.formPending[index].amount = parseFloat(this.crud.formPending[index].maxAmount).toFixed(2)
            this.forceUpdateItem()
          } else {
            this.crud.formPending[index].amount = 0
            this.forceUpdateItem()
          }
        }

        this.validImputation(index)
        this.getAmountImputation()
      },
      validDiscounts(index){
        if(this.crud.formPending[index].discounts=='') {
          this.crud.formPending[index].discounts = 0
          this.crud.formPending[index].amount_discounts = 0
          this.crud.formPending[index].amount_discounts_iva = 0
          this.crud.formPending[index].amount_result = this.crud.formPending[index].amountPending
          this.crud.formPending[index].maxAmountPending = this.crud.formPending[index].amountPending
          this.crud.formPending[index].amount = 0          
          this.crud.formPending[index].check = false
        }

        var aliquot = 0
        if(this.crud.form.concepts && this.crud.form.concepts.iva_conditions) {
          aliquot = this.crud.form.concepts.iva_conditions.aliquot
        }

        var calcDiscounts = (parseFloat(this.crud.formPending[index].amountNet) * parseFloat(this.crud.formPending[index].discounts)) / 100             
        var calcDiscountsTotal = calcDiscounts + ((calcDiscounts * aliquot) / 100)

        this.crud.formPending[index].amount_discounts = parseFloat(calcDiscountsTotal).toFixed(2)
        this.crud.formPending[index].amount_discounts_iva = (calcDiscounts * aliquot) / 100
        this.crud.formPending[index].amount_result = parseFloat(this.crud.formPending[index].amountPending).toFixed(2) - parseFloat(calcDiscountsTotal).toFixed(2)
        this.crud.formPending[index].amount = parseFloat(this.crud.formPending[index].amount_result).toFixed(2)   
        this.crud.formPending[index].maxAmountPending = this.crud.formPending[index].amount_result        

        this.forceUpdateItem()

        if( parseFloat(calcDiscountsTotal) > parseFloat(this.crud.formPending[index].maxAmount)) {          
          this.crud.formPending[index].discounts = 0
          this.crud.formPending[index].amount_discounts = 0
          this.crud.formPending[index].amount_discounts_iva = 0
          this.crud.formPending[index].amount_result = this.crud.formPending[index].amountPending
          this.crud.formPending[index].maxAmountPending = this.crud.formPending[index].amountPending
          this.crud.formPending[index].amount = 0          
          this.crud.formPending[index].check = false
          this.$awn.alert("El descuento no puede ser mayor al total pendiente de imputación");
          this.forceUpdateItem()
        }

        if( parseFloat(this.crud.formPending[index].discounts) < 0) {          
          this.crud.formPending[index].discounts = 0
          this.crud.formPending[index].amount_discounts = 0
          this.crud.formPending[index].amount_discounts_iva = 0
          this.crud.formPending[index].amount_result = this.crud.formPending[index].amountPending
          this.crud.formPending[index].maxAmountPending = this.crud.formPending[index].amountPending
          this.crud.formPending[index].amount = 0          
          this.crud.formPending[index].check = false
          this.$awn.alert("No es posible un descuento menor a cero");
          this.forceUpdateItem()
        }   
                
        if( parseFloat(this.crud.formPending[index].discounts) == 0) {         
          this.crud.formPending[index].discounts = 0 
          this.crud.formPending[index].amount_discounts = 0
          this.crud.formPending[index].amount_discounts_iva = 0
          this.crud.formPending[index].amount_result = this.crud.formPending[index].amountPending       
          this.crud.formPending[index].maxAmountPending = this.crud.formPending[index].amountPending
          this.crud.formPending[index].amount = 0          
          this.crud.formPending[index].check = false
          this.forceUpdateItem()
        }                   
        
        this.validImputation(index)   
        this.getAmountImputation()             
        this.getDiscountsImputation()
      },        
      validAmount(index){     
        if(this.crud.form.selectDestination == 'discounts') {     
          if(this.crud.formPending[index].amount=='') {
            this.crud.formPending[index].discounts = 0
            this.crud.formPending[index].amount = 0
            this.crud.formPending[index].check = false
          }
                        
          if( parseFloat(this.crud.formPending[index].amount) > parseFloat(this.crud.formPending[index].maxAmountPending)) {          
            this.crud.formPending[index].amount = parseFloat(this.crud.formPending[index].maxAmountPending).toFixed(2)
            this.forceUpdateItem()
          }

          if( parseFloat(this.crud.formPending[index].amount) <= 0) {          
            this.crud.formPending[index].amount = parseFloat(this.crud.formPending[index].maxAmount).toFixed(2)          
            this.crud.formPending[index].check = false
            this.forceUpdateItem()
          }        
        } else {
          if(this.crud.formPending[index].amount=='') {
            this.crud.formPending[index].amount = 0
            this.crud.formPending[index].check = false
          }
                        
          if( parseFloat(this.crud.formPending[index].amount) > parseFloat(this.crud.formPending[index].maxAmount)) {          
            this.crud.formPending[index].amount = parseFloat(this.crud.formPending[index].maxAmount).toFixed(2)
            this.forceUpdateItem()
          }

          if( parseFloat(this.crud.formPending[index].amount) <= 0) {          
            this.crud.formPending[index].amount = parseFloat(this.crud.formPending[index].maxAmount).toFixed(2)          
            this.crud.formPending[index].check = false
            this.forceUpdateItem()
          }             
        }

        this.validImputation(index)   
        this.getAmountImputation()     
      },
    
      validImputation(index) {
        if(this.crud.form.payment) {
          if(this.crud.formPending) {            
            var imputation = this.getImputation

            var amount = 0
            var valid = parseFloat(this.crud.form.payment.total) - parseFloat(imputation)            
            if( valid.toFixed(2) < 0) {
              amount = parseFloat(this.crud.formPending[index].amount) - (parseFloat(imputation) - parseFloat(this.crud.form.payment.total))
              this.crud.formPending[index].amount = parseFloat(amount.toFixed(2))
                          
              if(Math.abs(parseFloat(amount.toFixed(2))) <= 0) {
                this.crud.formPending[index].check = false
              }

              var positiveBalance = parseFloat(this.crud.form.payment.total) - parseFloat(this.getImputation)            
              this.calc.positiveBalance = parseFloat(positiveBalance.toFixed(2))
              this.calc.positiveBalanceFormat = Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrencyCode}).format(this.calc.positiveBalance)             
              
              this.forceUpdateItem()
            } else {
              amount = parseFloat(this.crud.form.payment.total) - parseFloat(imputation)              
              this.calc.positiveBalance = parseFloat(amount.toFixed(2))
              this.calc.positiveBalanceFormat = Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrencyCode}).format(this.calc.positiveBalance)             

              this.forceUpdateItem()
            }
          }
        }        
      },
      getAmountImputation() {        
        var imputation = 0
        if(this.crud.formPending) {          
          this.crud.formPending.forEach(element => {             
            if(element.check) {    
              if(element.operation == '+') {
                imputation = parseFloat(imputation) + parseFloat(element.amount)
              } else {
                imputation = parseFloat(imputation) - parseFloat(element.amount)
              }
            }
          });   
        }
        this.calc.imputation = parseFloat(imputation).toFixed(2)
        this.resetControl = true   
      },      
      getDiscountsImputation() {        
        var discounts = 0
        var discountsIva = 0
        if(this.crud.formPending) {          
          this.crud.formPending.forEach(element => {             
            if(element.check) {    
              if(element.operation == '+') {
                discounts = parseFloat(discounts) + parseFloat(element.amount_discounts)
                discountsIva = parseFloat(discountsIva) + parseFloat(element.amount_discounts_iva)
              } else {
                discounts = parseFloat(discounts) - parseFloat(element.amount_discounts)
                discountsIva = parseFloat(discountsIva) - parseFloat(element.amount_discounts_iva)
              }
            }
          });   
        }
        this.calc.discounts = discounts        
        this.calc.discountsIva = discountsIva        
      },         
      loadFormImpuation() {
        this.crud.form.imputation = []        
        if(this.crud.formPending.length) {
          this.crud.formPending.forEach(element => {                  
            if(element.check && element.amount>0) {  
              if(this.crud.form.selectDestination == 'discounts') {
                this.crud.form.imputation.push({                
                  'id': element.id,               
                  'amount': element.amount,               
                  'discount': element.amount_discounts, 
                  'discount_percentage': element.discounts, 
                  'discount_iva': element.amount_discounts_iva, 
                })                            
              } else {
                this.crud.form.imputation.push({                
                  'id': element.id,               
                  'amount': element.amount,
                })                
              }
            }
          });
        }        
      },
      forceUpdateItem() {
        this.itemForceUpdate = this.itemForceUpdate + 1
      },        

      // SELECT VOUCHER 
      searchVoucherByCustomer() {
        if(!this.crud.form.id) {
          if(this.crud.form.customers_id && this.crud.form.points_sales_id ) {
            var result = serviceAPI.obtenerVoucherByCustomer({
              'customers_id': this.crud.form.customers_id,
              'point_sale_id': this.crud.form.points_sales_id,
              'reference': this.crud.form.selectTypeVoucher,
            });
            result.then((response) => {    
              this.crud.form.types_vouchers_id = response.data[0].id							
              this.searchVoucher()                          
            })
            .catch(error => {
              this.$awn.alert(Error.showError(error));
            })   						           
          }
        } else {                                      
          if( this.crud.form.types_vouchers ) {                          
            this.modal.form.title = this.crud.form.types_vouchers.name
            this.modal.form.title = this.modal.form.title + ' ' + this.crud.form.points_sales.point_sale.toString().padStart(4,'0')
            this.modal.form.title = this.modal.form.title + '-' + this.crud.form.number.toString().padStart(8,'0')
          }                   
        }
      },			
      searchVoucher() {
        if(!this.crud.form.id) {
          if(this.crud.form.customers_id && this.crud.form.points_sales_id ) {
            var result = serviceAPI.obtenerVoucherById({
              'points_sales_id': this.crud.form.points_sales_id,
              'types_vouchers_id' : this.crud.form.types_vouchers_id,
            });
            result.then((response) => {                      
              this.crud.form.types_vouchers = response.data.type_voucher
              this.crud.form.letter = response.data.type_voucher.letter                    
              this.crud.form.number = response.data.number
          
              if( this.crud.form.types_vouchers ) {              
                this.modal.form.title = this.crud.form.types_vouchers.name
                this.modal.form.title = this.modal.form.title + ' ' + this.crud.form.points_sales.point_sale.toString().padStart(4,'0')
                this.modal.form.title = this.modal.form.title + '-' + this.crud.form.number.toString().padStart(8,'0')
              }                                
            })
          }
        } else {                                      
          if( this.crud.form.types_vouchers ) {                          
            this.modal.form.title = this.crud.form.types_vouchers.name          
            this.modal.form.title = this.modal.form.title + ' ' + this.crud.form.points_sales.point_sale.toString().padStart(4,'0')
            this.modal.form.title = this.modal.form.title + '-' + this.crud.form.number.toString().padStart(8,'0')
          }                   
        }
      },  

      // FILTER
      filterLoad() {   
        this.filterLoadCustomers()          
        this.filterLoadPointSale()                
        this.filters.date_start = moment().subtract(30, 'days').format('YYYY-MM-DD') 
        this.filters.date_end = moment().format('YYYY-MM-DD') 
      },
      filterLoadCustomers() {
        var result = serviceAPI.obtenerClientes()        
        result.then((response) => {
          var data = response.data    

          this.arr.filters.customers = []
          data.forEach(element => {            
            if(element.code) {
              this.arr.filters.customers.push({ code: element.id, label: element.code + ' | ' + element.name })            
            } else {
              this.arr.filters.customers.push({ code: element.id, label: element.name })            
            }            
          });          
        })   
      },
      filterLoadPointSale() {
        var result = serviceAPI.obtenerPuntosVentas()        
        result.then((response) => {
          var data = response.data    

          this.arr.filters.points_sales = []
          data.forEach(element => {                            
            this.arr.filters.points_sales.push({ code: element.id, label: element.full_identification })            
          });          
        })   
      },       
      filterReceipts(forceOpenSub=false) {
        this.table.isBusy = true
        var result = serviceAPI.filtrarRecibosTrashed(this.filters, this.table.currentPage)        
        result.then((response) => {          
          var data = response.data
          this.table.tablePaginate = data

          this.table.items = data.data
          this.arr.receipts = data.data
          this.prepareExport(data.data)
          
          this.table.items.forEach(element => {
            if(element.amount_pending>0) {
              element._rowVariant = 'warning'                          
            }
          })  

          this.table.items.forEach(element => {            
            if(forceOpenSub) {
              if(element.id == this.itemSelected.id) {
                this.openSub(element)
              }              
            }                
          });

          if(this.table.rowSelected!=null) {            
            this.table.items[this.table.rowSelected]._showDetails = true                   
          }         

          if(this.$refs.table) {            
            this.$refs.table.$forceUpdate()
          }          
            
          this.table.isBusy = false
        })           
        .catch(error => {                     
          this.table.isBusy = false  
          this.$awn.alert(ErrorToken.valid(error));
        })  
      },    

      // COMPROBANTE DETAIL
      openSub(item) {                
        this.itemSelected = item        
   
        this.tableSubPayment.items = item.details_payments_trashed
        this.tableSubImputation.items = item.details_imputations_trashed
        this.loadStyleConfig()
      },    
      hideSub() {
        this.tableSubPayment.items=[]
        this.tableSubImputation.items=[]
        this.itemSelected = null
      },               
      openDetail() {        
        // si tiene nc por descuento asociada, muestro la columna descuento        
        if(this.itemSelected.sales_nc_discounts_id) {
          this.loadFieldTable(true)
        } else {
          this.loadFieldTable(false)
        }
        // fin

        this.tableDetailPayment.items = this.itemSelected.details_payments_trashed
        this.tableDetailImputation.items = this.itemSelected.details_imputations_trashed

        if(this.itemSelected.accounting_entries_trashed){
          if(this.itemSelected.accounting_entries_trashed.details_trashed){
            this.tableAccounting.items = this.itemSelected.accounting_entries_trashed.details_trashed
          } else {
            this.tableAccounting.items = []
          }
        } else {
          this.tableAccounting.items = []
        }

        this.modal.detail.title = "Detalle del Recibo"
        this.modal.detail.active = true
      },       
      calcPendingVoucher(item) {                
        return parseFloat(item.sales.amount_total) - parseFloat(item.sales.amount_impute) -  parseFloat(item.discount_amount_nc) - parseFloat(item.amount_total) 
      },      
      
      // ACTION
      approvalReceipts(item) {
        this.$bvModal.msgBoxConfirm('¿Desea aprobar el Recibo?', {
          title: 'Aprobación Recibo',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: 'APROBAR',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: 'success',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {              
            let loader = this.$loading.show();
              
            var result = serviceAPI.aprobarRecibosTrashed({
              id: item.id
            });

            result.then((response) => {                            
              this.modal.form.active = false        
              loader.hide()
              this.filterReceipts()
              this.$awn.success("Recibo Aprobado");              
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })            
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })             
      },
      disapproveReceipts(item) {        
        this.$bvModal.msgBoxConfirm('¿Desea desaprobar el Recibo?', {
          title: 'Desaprobación Recibo',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'GENERAR',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {          
          if (value) {              
            let loader = this.$loading.show();
              
            var result = serviceAPI.desaprobarRecibosTrashed({
              id: item.id
            });

            result.then((response) => {                            
              this.modal.form.active = false        
              loader.hide()
              this.filterReceipts()
              this.$awn.success("Recibo NO Aprobado");              
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })                          
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })   
      },

      /****************
       * CONTABILIDAD *
       * **************/      
      getContabilidad() {          
        if(this.crud.form.selectDestination == 'discounts') {
          /*##############################*/
          /*####### ASIENTO RECIBO #######*/
          /*##############################*/          
          this.contabilidad.render = false
          this.contabilidad.typeDebe = ""
          this.contabilidad.typeHaber = "",
          this.contabilidad.defaultDebe = []
          this.contabilidad.defaultHaber = []
          this.contabilidad.reference = this.getRefVoucher   
          this.contabilidad.amountTotal = parseFloat(this.crud.form.payment.total)
          
          // ASIENTO POR DEFECTO         
          this.contabilidad.defaultDebe = this.getContabilidadAsientoRecibo('debe')
          this.contabilidad.defaultHaber = this.getContabilidadAsientoRecibo('haber')        
          // END
          
          this.contabilidad.render = true          

          /*##########################*/
          /*####### ASIENTO NC #######*/
          /*##########################*/
          this.contabilidadNC.render = false
          this.contabilidadNC.typeDebe = ""
          this.contabilidadNC.typeHaber = "",
          this.contabilidadNC.defaultDebe = []
          this.contabilidadNC.defaultHaber = []
          this.contabilidadNC.reference = 'NOTA DE CREDITO (DESCUENTO)'
          this.contabilidadNC.amountTotal = parseFloat(this.calc.discounts)

          // ASIENTO POR DEFECTO         
          this.contabilidadNC.defaultDebe = this.getContabilidadAsientoNC('debe')
          this.contabilidadNC.defaultHaber = this.getContabilidadAsientoNC('haber')        
          // END
          
          this.contabilidadNC.render = true                              
        } else {
          /*##############################*/
          /*####### ASIENTO RECIBO #######*/
          /*##############################*/            
          this.contabilidad.render = false
          this.contabilidad.typeDebe = ""
          this.contabilidad.typeHaber = "",
          this.contabilidad.defaultDebe = []
          this.contabilidad.defaultHaber = []
          this.contabilidad.reference = this.getRefVoucher   
          this.contabilidad.amountTotal = parseFloat(this.crud.form.payment.total)
          
          // ASIENTO POR DEFECTO         
          this.contabilidad.defaultDebe = this.getContabilidadAsientoRecibo('debe')
          this.contabilidad.defaultHaber = this.getContabilidadAsientoRecibo('haber')        
          // END
          
          this.contabilidad.render = true   
        }
                
        this.forceUpdate()
      },

      getAsiento(object) {
        this.crud.form.accountingEntry = object
      },
      getAsientoNC(object) {
        this.crud.form.accountingEntryNC = object
      },

      forceUpdate() {
        this.itemAccountingForceUpdate = this.itemAccountingForceUpdate + 1
      },

      getContabilidadAsientoRecibo(type) {                
        if(type == 'debe') {                  
          var arrDebe = []

          if(this.crud.form.payment.cash.detail) {
            this.crud.form.payment.cash.detail.forEach(element => {
              arrDebe.push({
                account: element.cash.accounting_account_default,
                amount: parseFloat(element.total),
                disabled: true,
              })
            });            
          }

          if(this.crud.form.payment.cheques.detail) {
            this.crud.form.payment.cheques.detail.forEach(element => {
              arrDebe.push({
                account: element.accounting_account_default,
                amount: parseFloat(element.total),
                disabled: true,
              })
            });
          }

          return arrDebe
        }        

        if(type == 'haber') {        
          var arrHaber = [
            {
              account: this.crud.form.customers.accounting_account_default,
              amount: parseFloat(this.crud.form.payment.total),
              disabled: true,
            }                
          ]            

          return arrHaber
        }        
      },      
      getContabilidadAsientoNC(type) {                
        if(type == 'debe') {                  
          var arrDebe = []
          
          arrDebe.push({
            account: this.crud.form.customers.accounting_account_secondary,
            amount: parseFloat(this.calc.discounts) - parseFloat(this.calc.discountsIva),
            disabled: true,
          });

          arrDebe.push({
            account: this.crud.form.concepts.iva_conditions.accounting_account_default,
            amount: parseFloat(this.calc.discountsIva),
            disabled: true,                  
          })            
          
          return arrDebe
        }        

        if(type == 'haber') {        
          var arrHaber = []

          arrHaber.push({
            account: this.crud.form.customers.accounting_account_default,
            amount: parseFloat(this.calc.discounts),
            disabled: true,
          })

          return arrHaber
        }        
      },                
    }
  }
</script>
<style>
  .crud-receipts-title {
    font-size: 15px;
    font-weight: 600;
  }
  .crud-receipts-code {
    color: gray;
    font-size: 12px;
  }   
  #details_items {
    position: fixed;
    right: 15px;    
  }     
  .table-receipts-sub {
    overflow: auto;
    max-height: 350px;
  }
  .crud-receipts-title-table-custom {
    color: #fff;
    background-color: #2f353a;
    border-color: #40484f;
    font-weight: 700;
    padding-right: 10px;
    width: 30%;
    text-align: right
  }
  .crud-receipts-value-table-custom {
    padding-left: 5px;
    white-space: pre-line;
  }  
  .table-full-detail-receipts {
    overflow: auto;
    max-height: 350px;    
  }  
  .crud-receipts-totales-items-header {
    background: var(--dark);
    color: #fff;
    font-size: 12px;
    padding-right: 10px;
    padding-top: 2px;
    padding-bottom: 2px;    
    text-align: right;
    font-weight: 700;
  }
  .crud-receipts-counts-items {
    font-size: 12px;    
    text-align: right;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;    
    border-color: var(--dark);
    border-style: solid;
    border-width: 1px;    
  }  
  .crud-receipts-totales-items {
    font-size: 12px;    
    text-align: right;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;    
    border-color: var(--dark);
    border-style: dotted;
    border-width: 1px;    
  }    
  .crud-receipts-wizard .wizard-header {
    padding: 0px;
  }  
  .crud-receipts-item-input {
    height: 25px;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
  }
  .crud-receipts-table-items {
    height: 400px;    
    overflow: auto;
  }
  .receipts-payments-add-total {
    font-weight: 800 !important;
    font-size: 15px !important;    
    text-align: right;
  }
  .receipts-payments-add-total-final {
    font-weight: 800 !important;
    font-size: 15px !important;    
    text-align: right;
  }  
  .receipts-imputation-total-align {
    margin-top: 25px;
  }
</style>
<style scoped>
  .b-avatar {
    width: 25px;
    height: 25px;    
  }  
</style>